import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-controls-text" }
const _hoisted_2 = { class: "table-controls-right" }
const _hoisted_3 = { class: "table-controls-selector-wrapper" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Назначить")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Отмена")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiSelector = _resolveComponent("UiSelector")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_UiTable = _resolveComponent("UiTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_UiInput, {
      modelValue: _ctx.nalogPayers.filters.search,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nalogPayers.filters.search) = $event)),
      search: "",
      label: "Адрес, ИНН налогоплательщика или название объекта",
      placeholder: "Введите",
      inputId: "filterAddress",
      "use-options": "",
      options: _ctx.searchHint,
      "onUpdate:selectedRow": _cache[1] || (_cache[1] = ($event: any) => (_ctx.nalogPayers.filters.search = $event?.value || '')),
      style: {"width":"35rem","margin":"25px"}
    }, null, 8, ["modelValue", "options"]),
    _createElementVNode("div", {
      class: _normalizeClass(["table-controls", {'table-controls-active': _ctx.nalogPayers.selected.length }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.$tc('selected', _ctx.nalogPayers.selected.length)) + " ", 1),
        _createElementVNode("b", null, _toDisplayString(_ctx.nalogPayers.selected.length), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$tc('objects', _ctx.nalogPayers.selected.length)), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_UiSelector, {
            placeholder: "Назначить инспектора",
            options: _ctx.workers.rows,
            modelValue: _ctx.workers.selected,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.workers.selected) = $event))
          }, null, 8, ["options", "modelValue"])
        ]),
        _createVNode(_component_Btn, {
          class: "table-controls-btn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.nalogPayers.onAssign())),
          disabled: _ctx.nalogPayers.assigning || !(_ctx.workers.selected?.id)
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_Btn, {
          class: "table-controls-btn-outline",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.nalogPayers.selected = [])),
          disabled: _ctx.nalogPayers.assigning
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 2),
    _createVNode(_component_UiTable, {
      useCheckboxes: !_ctx.$store.state.auth.isCA,
      selectedRows: _ctx.nalogPayers.selected,
      "onUpdate:selectedRows": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.nalogPayers.selected) = $event)),
      cols: _ctx.cols,
      rows: _ctx.nalogPayers.rows,
      emptyBannerText: _ctx.nalogPayers.fetching ? 'Идет загрузка' : 'Налогоплательщики отсутствуют',
      onChangePage: _ctx.paginateHandler,
      pagination: _ctx.pagination
    }, null, 8, ["useCheckboxes", "selectedRows", "cols", "rows", "emptyBannerText", "onChangePage", "pagination"])
  ], 64))
}